/*
 * @Author: melon
 * @Date: 2020-07-04 23:17:14
 * @Last Modified by: melon
 * @Last Modified time: 2020-08-11 16:58:55
 */
// Servers
// Selectors

import { _getSubscribeInfo, _getSubscribeDetail,_payCallback,_upgrade,_getLevelOrder,_cancelLevelOrder,_upgradeLevelOrder,_deleteLevelOrder } from 'servers/subscribe'

import {
  SubscribeInfoSelector,
  SubscribeDetailSelector,
} from 'selectors/subscribe/SubscribeSelectors'
import {
  _editEnterpriseLevel,
} from 'servers/enterprise'

// Actions

// Action Creators

// init data

const initialState = {}

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    //...
    default:
      return state
  }
}

//异步action

export const getSubscribeInfo = async (data) => {
  const res = await _getSubscribeInfo(data)
  return new Promise(function (resolve, reject) {
    resolve(SubscribeInfoSelector(res))
    reject({})
  })
}

// 查询订阅详情
export const getSubscribeDetail = async (data) => {
  const res = await _getSubscribeDetail(data)
  return new Promise(function (resolve, reject) {
    resolve(SubscribeDetailSelector(res))
    reject({})
  })
}
// 查询订阅详情
export const editEnterpriseLevel = async (data) => {
  const res = await _editEnterpriseLevel(data)
  return new Promise(function (resolve, reject) {
    resolve(SubscribeDetailSelector(res))
    reject({})
  })
}
// 统一下单回调接口
export const payCallback = async (data) => {
  const res = await _payCallback(data)
  return new Promise(function (resolve, reject) {
    resolve(res)
    reject({})
  })
}
// 账号升级
export const upgrade = async (data) => {
  const res = await _upgrade(data)
  return new Promise(function (resolve, reject) {
    resolve(res)
    reject({})
  })
}
export const cancelLevelOrder = async (data) => {
  const res = await _cancelLevelOrder(data)
  return new Promise(function (resolve, reject) {
    resolve(res)
    reject({})
  })
}
export const upgradeLevelOrder = async (data) => {
  const res = await _upgradeLevelOrder(data)
  return new Promise(function (resolve, reject) {
    resolve(res)
    reject({})
  })
}
// 查询账号升级订单信息
export const getLevelOrder = async (data) => {
  const res = await _getLevelOrder(data)
  return new Promise(function (resolve, reject) {
    resolve(res)
    reject({})
  })
}
export const deleteLevelOrder = async (data) => {
  const res = await _deleteLevelOrder(data)
  return new Promise(function (resolve, reject) {
    resolve(res)
    reject({})
  })
}
